export default "__VITE_ASSET__JuFHLNXC__"